import Block from '../block'

export default class ThemeIframe extends Block {
	static title = 'theme-iframe'

	constructor($el) {
		super($el)

		$(document).on('palette:change', (event, name) => {
			const iframe = this.$el.get(0)

			if (iframe && iframe.contentWindow) {
				iframe.contentWindow.postMessage(
					{
						name: 'set.html.class',
						value: name,
					},
					'*',
				)
			}
		})

		window.addEventListener('message', (event) => {
			const iframe = this.$el.get(0)
			if (
				event.origin.includes('.pagewize.dev') ||
				event.origin.includes('.pagewize.site')
			) {
				if (event.data.name === 'get.html.class') {
					if (iframe && iframe.contentWindow) {
						const paletteName = $('input[name="palette"]:checked').val()

						iframe.contentWindow.postMessage(
							{
								name: 'set.html.class',
								value: paletteName,
							},
							'*',
						)

						setTimeout(() => {
							this.$el.css('opacity', 1)
						}, 100)
					}
				}

				if (event.data.name === 'set.invisible') {
					if (iframe && iframe.contentWindow) {
						this.$el.css('opacity', 0)
					}
				}
			}
		})
	}
}
